// extracted by mini-css-extract-plugin
module.exports = {"container":"BackButton-module--container--lLj3-","button":"BackButton-module--button--29Okm","dark":"BackButton-module--dark--1-1Sx","white":"BackButton-module--white--2H9OG"};